<template>
  <div>
    <div class="container">
      <div class="exclusive-top">
        <p>
          <span class="color">提示：</span>
          您申请的平台产品目录仅能用于向中国石化以外的外部客户销售商品，不适用于中国石化保供业务，不能向中国石化用户销售商品，尽请知悉。
        </p>
      </div>
      <!-- 操作 -->
      <el-row>
        <eui-btn type="weak" @click="handleExportCategory">导出</eui-btn>
        <div class="crumbs" style="margin-bottom: 5px">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClickTab">
            <el-tab-pane
              v-for="item in elTabPane"
              :key="item.name"
              :label="`${item.label}${item.num}`"
              :name="item.name"
            ></el-tab-pane>
          </el-tabs>
        </div>
      </el-row>
      <!-- 提示 -->
      <div class="exclusive-top" style="margin-bottom: 20px">
        <div>
          <span class="color">提示：</span>
          您的审核企业（服务管家）为：{{ abbreviation }}。审核联系人
          <span v-for="(item, index) in butlerInfo" :key="index">
            <span>{{ item.nickName }}：{{ item.mobile }}</span>
          </span>
        </div>
      </div>
      <!-- 搜索 -->
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="目录（末级）搜索：">
          <el-input v-model="listQuery.categoryName" clearable placeholder="请输入末级目录名称"></el-input>
        </el-form-item>
        <el-button type="primary" style="margin-left: 20px" @click="handleEndSearch">搜索</el-button>
      </el-form>
      <!-- 列表 -->
      <TableList :loading="loading" :table-data="tableData" :table-label="tableLabel" :index-show="indexShow">
        <template #name="slot">{{ slot.scope.row.categoryName }}</template>
      </TableList>
      <div v-if="activeName === '999'" class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import TableList from '@/modules/projectA/components/common/e-table-list';
import api from '@/modules/projectA/api/company/index';
import utils from '@/modules/projectA/utils/utils';
import _ from 'lodash';

export default {
  name: '',
  components: { TableList },
  props: {},
  data() {
    return {
      loading: false,
      indexShow: true,
      elTabPane: [
        {
          label: '已生效',
          name: '999',
          num: '',
        },
        {
          label: '已提交待审核',
          name: '102',
          num: '',
        },
        {
          label: '审核拒绝',
          name: '103',
          num: '',
        },
        {
          label: '审核通过',
          name: '104',
          num: '',
        },
      ],
      tableLabel: [],
      labelArr1: [
        {
          label: '产品目录名称',
          align: 'center',
          param: 'categoryName',
          slot: 'name',
        },
        {
          label: '目录状态',
          param: 'opeAuditStatus',
          align: 'center',
          render: (row) => {
            const obj = {
              101: '待审核',
              102: '待审核',
              103: '审核拒绝',
              104: '审核通过',
              105: '审核拒绝',
              106: '待审核',
              121: '待审核',
            };
            return obj[Number(row.opeAuditStatus)];
          },
        },
        { label: '申请时间', param: 'applyDate', align: 'center' },
        { label: '审核时间', param: 'opeAuditTime', align: 'center' },
      ],
      labelArr2: [
        {
          label: '产品目录名称',
          align: 'center',
          param: 'categoryName',
          slot: 'name',
        },
        {
          label: '目录状态',
          param: 'opeAuditStatus',
          align: 'center',
          width: '130',
          render: (row) => {
            const obj = {
              101: '待审核',
              102: '待审核',
              103: '审核拒绝',
              104: '审核通过',
              105: '审核拒绝',
              106: '待审核',
              121: '待审核',
            };
            return obj[Number(row.opeAuditStatus)];
          },
        },
        {
          label: '拒绝原因',
          align: 'left',
          param: 'opeAuditOpinion',
          width: '340',
        },
        {
          label: '申请时间',
          param: 'applyDate',
          align: 'center',
          width: '180',
        },
        {
          label: '审核时间',
          param: 'opeAuditTime',
          align: 'center',
          width: '180',
        },
      ],
      labelArr3: [
        {
          label: '产品目录名称',
          align: 'center',
          param: 'categoryName',
          slot: 'name',
        },
        {
          label: '目录状态',
          param: 'opeAuditStatus',
          align: 'center',
          render: (row) => {
            const obj = {
              101: '待审核',
              102: '待审核',
              103: '审核拒绝',
              104: '审核通过',
              105: '审核拒绝',
              106: '待审核',
              121: '待审核',
            };
            return obj[Number(row.opeAuditStatus)];
          },
        },
      ],
      tableData: [],
      dataNum: '',
      listTypeInfo: {
        tagTextForZoneIdsList: [],
        zoneList: [],
      },
      categoryVisible: false,

      activeName: '102',
      label: '已提交待审核',
      butlerInfo: [],
      abbreviation: '',
      // 2023-09-06迭代
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        categoryName: '',
      },
      total: 0,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.tableLabel = this.labelArr1;
    this.handleClickTab();
    this.queryCompanyButler();
  },
  methods: {
    handleExportCategory: _.debounce(async function () {
      const result = await api.exportCategory({});
      if (result?.code === '500') {
        return;
      }
      if (result.type == 'application/json') {
        utils.fileExportResponseError(result);
      } else {
        const time = utils.formatDate(new Date(), 'yyyyMMdd');
        utils.downFile(result, `产品目录信息${time}`);
      }
    }),
    // 顶部选项卡
    handleClickTab(ev) {
      this.label = ev ? ev.label : '已提交待审核';
      if (this.activeName == '999') {
        this.tableLabel = this.labelArr3;
        this.listQuery.opeAuditStatus = '104';
        this.queryCompanyEffectiveCategory(this.listQuery);
      } else {
        this.tableLabel = this.activeName == '103' ? this.labelArr2 : this.labelArr1;
        this.queryCompanyCategoryPage(this.listQuery);
      }
    },

    // 供应商产品目录列表
    queryCompanyCategoryPage() {
      const params = {
        opeAuditStatus: this.activeName,
        categoryName: this.listQuery.endCatalogName,
      };
      api.queryCompanyCategoryPage(params).then((res) => {
        console.log(res, '水电费第三方');
        this.tableData = res.data;
        this.tableData.length &&
          this.tableData.forEach((item) => {
            if (item.opeAuditOpinion == undefined) {
              item.opeAuditOpinion = '无';
            }
          });
        this.total = res.total || 0;
        this.dataNum = `（${res.data.length}）`;
        this.elTabPane.map((item) => {
          if (item.label[2] == this.label[2]) {
            item.num = this.dataNum;
          } else {
            item.num = '';
          }
        });
      });
    },

    // 查询供应商 已生效的产品目录
    queryCompanyEffectiveCategory(params) {
      /* let params = {
        opeAuditStatus: '104',
        categoryName: this.listQuery.endCatalogName
      }; */
      api.queryCompanyEffectiveCategoryPage(params).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total || 0;
        this.dataNum = `（${res.data.total}）`;
        this.elTabPane.map((item) => {
          if (item.label[2] == this.label[2]) {
            item.num = this.dataNum;
          } else {
            item.num = '';
          }
        });
      });
    },

    // 服务管家
    async queryCompanyButler() {
      const res = await api.queryCompanyButler();
      if (res.code == '200' && res.data.length) {
        this.butlerInfo = res.data;
        const endMobile = this.butlerInfo[this.butlerInfo.length - 1].mobile;
        this.abbreviation = this.butlerInfo[0].abbreviation;
        this.butlerInfo.forEach((item) => (item.mobile = `${item.mobile}、`));
        this.butlerInfo[this.butlerInfo.length - 1].mobile = `${endMobile}。`;
      }
    },

    // 末级目录搜索
    handleEndSearch() {
      if (this.activeName == '999') {
        this.listQuery.pageNum = 1;
        // 查询供应商已生效的产品目录
        this.queryCompanyEffectiveCategory(this.listQuery);
      } else {
        // 查询其他产品目录
        this.queryCompanyCategoryPage();
      }
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.queryCompanyEffectiveCategory(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.queryCompanyEffectiveCategory(this.listQuery);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-table .cell {
  white-space: pre-line;
}
.exclusive-top {
  width: 100%;
  min-height: 44px;
  line-height: 44px;
  background: #e8efff;
  box-sizing: border-box;
  padding: 0 20px;
  margin-bottom: 10px;
  p {
    font-size: 16px;
    color: #333;
  }
  .color {
    color: #ef4c56;
    font-weight: bold;
  }
}
</style>
